@if (Error) {
  <mj-empty-state Variant="error" Title="Couldn't load your committee view" [Message]="Error"><div actions><button type="button" mjButton variant="primary" (click)="Refresh()">Try again</button></div></mj-empty-state>
} @else if (NoSeason) {
  <mj-empty-state Variant="empty" Title="OEP is between seasons" Message="There is no active OEP season yet. We will email you when your role opens." />
} @else if (NoCommittee) {
  <mj-empty-state Variant="empty" Title="No section committee yet" Message="If you expected one, reply to your OEP email or write to membership@agu.org." />
} @else if (VM) {
<section class="oep-comm" [attr.aria-busy]="Busy">
  <!-- markup.html:763-764 -->
  <h1 class="oep-comm__h1">{{ VM.Title }}</h1>
  <p class="oep-comm__intro">{{ VM.Intro }}</p>
  <!-- A member of two sections' committees chooses one (T28 fix round 1); the choice is the location's record ID. -->
  @if (Sections.length > 1) {
    <div class="oep-comm__sections">
      <span class="oep-comm__sections-label" id="oep-comm-sections">Your sections</span>
      <agu-segmented class="oep-comm__seg" [Options]="Sections" [Value]="CurrentSectionID" GroupLabel="Your sections" LabelledBy="oep-comm-sections" (ValueChange)="ChooseSection($event)" />
    </div>
  }

  <!-- markup.html:766-776: before Selecting -->
  @if (VM.Locked; as l) {
    <div class="oep-comm__locked">
      <h2 class="oep-comm__lock-title">{{ l.Title }}</h2>
      <p class="oep-comm__lock-body">{{ l.Body }}</p>
      @if (l.Links.length) {
        <ul class="oep-comm__links">
          @for (r of l.Links; track $index) {
            <li><a [href]="r.Url" target="_blank" rel="noopener">{{ r.Title }}<span class="oep-sr"> (opens in a new tab)</span></a></li>
          }
        </ul>
      }
    </div>
  }

  <!-- markup.html:778-837: Selecting (editable) and Complete (read-only) -->
  @if (VM.Open; as o) {
    <!-- markup.html:780-787 commStats -->
    <ul class="oep-comm__stats">
      @for (s of o.Stats; track s.Label) {
        <li><mj-stat-badge class="oep-comm__stat" [Count]="s.Value" [Label]="s.Label" /></li>
      }
    </ul>

    <!-- markup.html:789-792 -->
    <div class="oep-comm__scope">
      <p class="oep-comm__scope-note">{{ o.ScopeNote }}</p>
      <button type="button" class="oep-comm__export" [attr.data-state]="o.Exported ? 'done' : null" [disabled]="Busy" (click)="Export()">{{ o.ExportLabel }}</button>
    </div>

    <!-- markup.html:794-827 nominees -->
    @if (o.Nominees.length === 0) {
      <p class="oep-comm__none">No nominations were submitted for this section.</p>
    }
    <ul class="oep-comm__nominees">
      @for (n of o.Nominees; track n.PresentationID) {
        <li class="oep-comm__card" [attr.data-picked]="n.Picked" [attr.aria-labelledby]="'oep-comm-t-' + n.PresentationID">
          <div class="oep-comm__head">
            <div class="oep-comm__body">
              @for (s of n.Sources; track $index) { <span class="oep-comm__source">{{ s }}</span> }
              <h2 class="oep-comm__title" [id]="'oep-comm-t-' + n.PresentationID">{{ n.Title }}</h2>
              <div class="oep-comm__line">{{ n.Line }}</div>
            </div>
            <div class="oep-comm__actions">
              <button type="button" class="oep-comm__pick" [attr.data-tone]="n.Pick.Tone" [disabled]="!n.Pick.Enabled || Busy" (click)="Pick(n)">{{ n.Pick.Label }}</button>
              <button type="button" class="oep-comm__expand" [attr.aria-expanded]="n.Expanded" [attr.aria-controls]="n.DetailsID" (click)="Toggle(n)">{{ n.ExpandLabel }}</button>
            </div>
          </div>

          <!-- markup.html:808-824 -->
          <div class="oep-comm__details" [id]="n.DetailsID" [hidden]="!n.Expanded">
            <div class="oep-comm__col">
              <h3 class="oep-comm__eyebrow">Nomination</h3>
              @for (x of n.Nominations; track $index) {
                <div class="oep-comm__block">
                  @if (n.Nominations.length > 1) { <div class="oep-comm__who">{{ x.Source }}</div> }
                  <dl class="oep-comm__scores">
                    @for (s of x.Scores; track s.Label) {
                      <div class="oep-comm__score"><dt>{{ s.Label }}</dt><dd>{{ s.Value }}@if (s.Justification) { <p class="oep-comm__just">{{ s.Justification }}</p> }</dd></div>
                    }
                  </dl>
                  @if (x.Additional) {
                    <h4 class="oep-comm__sub">Additional reasoning</h4>
                    <p class="oep-comm__text">{{ x.Additional }}</p>
                  }
                </div>
              }
              @if (n.FinalFileID) {
                <button type="button" class="oep-comm__file" (click)="ViewFinal(n)">View the final presentation<span class="oep-sr"> (opens in a new tab)</span></button>
              }
            </div>
            <div class="oep-comm__col">
              <h3 class="oep-comm__eyebrow">Draft feedback round</h3>
              @for (r of n.Reviews; track $index) {
                <div class="oep-comm__block">
                  <h4 class="oep-comm__sub">{{ r.Heading }}</h4>
                  <dl class="oep-comm__scores">
                    @for (s of r.Scores; track s.Label) {
                      <div class="oep-comm__score"><dt>{{ s.Label }}</dt><dd>{{ s.Value }}</dd></div>
                    }
                  </dl>
                  <!-- markup.html:421-424 -->
                  <h5 class="oep-comm__eyebrow">What worked</h5>
                  <p class="oep-comm__text">{{ r.Strengths }}</p>
                  @if (r.Suggestions) {
                    <h5 class="oep-comm__eyebrow">Suggestions before the meeting</h5>
                    <p class="oep-comm__text">{{ r.Suggestions }}</p>
                  }
                </div>
              } @empty {
                <p class="oep-comm__none">No reviewer feedback was released for this presentation.</p>
              }
            </div>
          </div>
        </li>
      }
    </ul>

    <!-- markup.html:829-835 -->
    <div class="oep-comm__footer">
      <div class="oep-comm__tally" aria-live="polite">
        <strong class="oep-comm__selected">{{ o.SelectedLabel }}</strong>
        <div class="oep-comm__note">{{ o.SubmitNote }}</div>
      </div>
      <button type="button" class="oep-comm__submit" [attr.data-state]="o.Submitted ? 'done' : null" [disabled]="!o.CanSubmit || Busy" (click)="Submit()">{{ o.SubmitLabel }}</button>
    </div>
  }
  <p class="oep-comm__status" role="status" aria-live="polite" [attr.data-tone]="Status?.Tone">{{ Status?.Text }}@if (Status?.Link; as l) { <a [href]="l.Url" target="_blank" rel="noopener">{{ l.Label }}<span class="oep-sr"> (opens in a new tab)</span></a> }</p>
</section>
}
